import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "InactiveSessionExpired": "Due to prolonged inactivity, your session has expired. Please log in again."
})
i18n.mergeLocaleMessage('zh', {
  "InactiveSessionExpired": "系统检测您长时间未操作，你的会话已过期，请重新登录"
})
i18n.mergeLocaleMessage('mm', {
  "InactiveSessionExpired": "အကြာကြီးလုပ်ငန်းမလုပ်ထားသည့်အတွက် သင်၏ဆက်သွယ်မှုအချိန်ကုန်သွားပြီဖြစ်သောကြောင့် ထပ်မံလော့ဂ်အင်ဝင်ပါ။"
})
  